import { net_filemanage } from "@/api/http";

export const API_STFMFM02C06_Initialize = (...params) =>
net_filemanage.post("/api/STFMFM02C06/Initialize", ...params);

export const API_STFMFM02C06_UpdateFolder = (...params) =>
net_filemanage.post("/api/STFMFM02C06/UpdateFolder", ...params);

export const API_STFMFM02C06_UnLockFolder = (...params) =>
net_filemanage.post("/api/STFMFM02C06/UnLockFolder", ...params);